import React, { FC, useState } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewWillEnter } from '@ionic/react'
import { UseHeader, MktEmpty } from '@cps'
import { memberMobx } from '@mobxStore'
import ActivityApi from '@api/activity.api'
import { format } from '@dt/fe-utils'
import { useHistoryNew } from '@utils'
import i18n from 'i18next'
import './index.scss'

interface IProps extends IPage, RouteComponentProps { }

const MyPrizes: FC<IProps> = ({ match }) => {
  const history = useHistoryNew()
  const { activityId } = match.params as any
  const [prizes, setPrizes] = useState<any>([])
  const [userInfo, setUserInfo] = useState<any>({})
  const goBack = () => {
    history.goBack()
  }
  useIonViewWillEnter(() => {
    ActivityApi.invitationMemberList({ brandId: memberMobx.brandId, activityId: activityId }).then((res: any) => {
      if (res?.length > 0) {
        setPrizes(res.reverse())
        ActivityApi.getMemberInfo({ brandId: memberMobx.brandId, memberIds: res.map(ids => ids.invitationMemberId) }).then(userInfo => {
          setUserInfo(userInfo)
        })
      }
    })
  }, [])
  return (
    <IonPage className='invitation-member-page'>
      <UseHeader title={i18n.t('mkt.activity.invitedMember')} onBack={goBack}></UseHeader>
      <IonContent className='page-content'>
        {
          prizes.length > 0 && userInfo ? (
            <div className='page-body'>
              {prizes.map((item: any, index: number) =>
                <div className='info' key={index}>
                  <div className='title'>{userInfo[item.invitationMemberId]?.nickName}</div>
                  <div className='times'>{format.toDateTime(item.addTime)}</div>
                </div>)}
            </div>) : <MktEmpty text={i18n.t('mkt.activity.noInvitedNum')}></MktEmpty>
        }
      </IonContent>
    </IonPage>
  )
}

export default observer(MyPrizes)
